import { AlertService } from '../../services/alert/alert.service'
import { FormGroup } from '@angular/forms'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { NavController } from '@ionic/angular'
import { UserService, IUser } from 'src/app/services/user/user.service'

@Component({
  selector: 'app-changepw',
  templateUrl: './changepw.page.html',
  styleUrls: ['./changepw.page.scss'],
})
export class ChangepwPage implements OnInit, OnDestroy {

  user: IUser
  userSubscription: any

  constructor(
    private navCtrl: NavController,
    private userService: UserService,
    private alert: AlertService
  ) { }

  ngOnInit() {
    this.userSubscription = this.userService.currentUser.subscribe(value => this.user = value)
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
  }

  changepw(form: FormGroup) {
    if (form.value.password1 !== form.value.password2)
      this.alert.alertPrompt('Passwörter stimmen nicht überein', 'Warnung')
        .then(() => {
          return
        })
    else {

      const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/

      if (!re.test(form.value.password1))
        this.alert.alertPrompt('Das Passwort muss mindestens 8 Zeichen lang sein, mit Zahl und Groß- / Kleinschreibung', 'Warnung')
          .then(() => {
            return
          })
      else
        this.userService.changepw(this.user.token, form.value.password1)
          .then(() => {
            return this.alert.alertPrompt('Das Passwort wurde erfolgreich geändert', 'Info')
          })
          .then(() => this.navCtrl.pop())
          .catch((err) => this.alert.errorHandler(err, true))
    }
  }
}
